import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faTimes,
    faBox,
    faStore,
    faList
} from '@fortawesome/free-solid-svg-icons';
import './EmbeddedSidebar.css';

const EmbeddedSidebar = ({ isOpen, onClose }) => {
    const navigate = useNavigate();
    const location = useLocation();

    // Agregar clase al body para ajustar el layout en desktop
    useEffect(() => {
        const isDesktop = window.innerWidth > 768;
        if (isDesktop) {
            document.body.classList.add('has-sidebar');
        } else {
            document.body.classList.add('has-mobile-header');
        }

        const handleResize = () => {
            if (window.innerWidth > 768) {
                document.body.classList.add('has-sidebar');
                document.body.classList.remove('has-mobile-header');
            } else {
                document.body.classList.remove('has-sidebar');
                document.body.classList.add('has-mobile-header');
            }
        };

        window.addEventListener('resize', handleResize);
        return () => {
            document.body.classList.remove('has-sidebar');
            document.body.classList.remove('has-mobile-header');
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const menuItems = [
        { path: '/my-products', icon: faBox, label: 'Mis Productos' },
        { path: '/my-private-catalog', icon: faList, label: 'Mis Catálogos' },
        { path: '/my-store', icon: faStore, label: 'Mi Tienda' }
    ];

    const handleNavigate = (path) => {
        navigate(path);
        if (onClose) onClose();
    };

    const handleClose = () => {
        if (onClose) onClose();
    };

    const isActive = (path) => {
        if (path === '/my-products') {
            // Considerar activo también cuando estamos editando un producto
            return location.pathname === path || location.pathname.startsWith('/edit-product');
        }
        return location.pathname === path;
    };

    return (
        <>
            {/* Overlay (solo móvil) */}
            {isOpen && (
                <div
                    className="embedded-sidebar-overlay"
                    onClick={handleClose}
                />
            )}

            {/* Sidebar */}
            <div className={`embedded-sidebar ${isOpen ? 'open' : ''}`}>
                <div className="embedded-sidebar-header">
                    <div className="embedded-sidebar-logo">
                        <svg viewBox="0 0 100 100" className="embedded-sidebar-logo-svg">
                            {/* Círculo exterior */}
                            <circle cx="50" cy="50" r="40" fill="none" stroke="currentColor" strokeWidth="3"/>
                            
                            {/* Libro izquierdo (azul) */}
                            <rect x="24" y="24.75" width="24.15" height="51.75" rx="3.5" fill="#4169E1"/>
                            
                            {/* Libro derecho (púrpura) */}
                            <rect x="51.85" y="24.75" width="24.15" height="51.75" rx="3.5" fill="#8B5CF6"/>
                            
                            {/* Líneas del libro izquierdo */}
                            <line x1="28" y1="34" x2="43" y2="34" stroke="white" strokeWidth="1.8" strokeLinecap="round"/>
                            <line x1="28" y1="45" x2="43" y2="45" stroke="white" strokeWidth="1.8" strokeLinecap="round"/>
                            <line x1="28" y1="56" x2="43" y2="56" stroke="white" strokeWidth="1.8" strokeLinecap="round"/>
                            
                            {/* Líneas del libro derecho */}
                            <line x1="57" y1="34" x2="72" y2="34" stroke="white" strokeWidth="1.8" strokeLinecap="round"/>
                            <line x1="57" y1="45" x2="72" y2="45" stroke="white" strokeWidth="1.8" strokeLinecap="round"/>
                            <line x1="57" y1="56" x2="72" y2="56" stroke="white" strokeWidth="1.8" strokeLinecap="round"/>
                            
                            {/* Punto decorativo verde */}
                            <circle cx="50" cy="85" r="3.5" fill="#10B981"/>
                        </svg>
                        <span className="embedded-sidebar-logo-text">OviCatalogos</span>
                    </div>
                    <button
                        className="embedded-sidebar-close"
                        onClick={handleClose}
                        aria-label="Cerrar menú"
                    >
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>

                <nav className="embedded-sidebar-nav">
                    {menuItems.map((item) => (
                        <button
                            key={item.path}
                            className={`embedded-sidebar-item ${isActive(item.path) ? 'active' : ''}`}
                            onClick={() => handleNavigate(item.path)}
                        >
                            <FontAwesomeIcon icon={item.icon} className="sidebar-icon" />
                            <span>{item.label}</span>
                        </button>
                    ))}
                </nav>
            </div>
        </>
    );
};

export default EmbeddedSidebar;
